var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSeeMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 6C8.52978 6 9.03849 6.21071 9.41356 6.58579C9.78864 6.96086 9.99935 7.46957 9.99935 8C9.99935 8.53043 9.78864 9.03914 9.41356 9.41421C9.03849 9.78929 8.52978 10 7.99935 10C7.46892 10 6.96021 9.78929 6.58514 9.41421C6.21006 9.03914 5.99935 8.53043 5.99935 8C5.99935 7.46957 6.21006 6.96086 6.58514 6.58579C6.96021 6.21071 7.46892 6 7.99935 6ZM7.99935 3C11.3327 3 14.1793 5.07333 15.3327 8C14.1793 10.9267 11.3327 13 7.99935 13C4.66602 13 1.81935 10.9267 0.666016 8C1.81935 5.07333 4.66602 3 7.99935 3ZM2.11935 8C3.21935 10.24 5.49268 11.6667 7.99935 11.6667C10.506 11.6667 12.7793 10.24 13.8793 8C12.7793 5.76 10.506 4.33333 7.99935 4.33333C5.49268 4.33333 3.21935 5.76 2.11935 8Z",
    fill: "#7687A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/seeMore.dac31c5a7735455f65069f00ef4cb67c.svg";
export { ForwardRef as ReactComponent };